function SecuritySettings() {
  return <div><h2>Security Settings</h2><p>Security and 2FA settings will go here.</p></div>;
}
export default SecuritySettings; 